import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import _forEach from "lodash/forEach";

import Dropdown from "components/Dropdown";
import Button from "components/Buttons";
import Toast from "components/Toast";
import Modal from "components/gads/Modal";
import dateFormatter from "modules/utils/DateFormatter";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import googleActions from "modules/google/actions";
import googleSelectors from "modules/google/selectors";
import facebookActions from "modules/facebook/actions";
import facebookSelectors from "modules/facebook/selectors";
import facebook from "../../sagas/facebook";
import Loading from "components/gads/Loading";
import formatValue from "modules/utils/formatValue";
import Input from "components/facebook/Input";
import Row from "components/Row";
import decodeHTMLEntities from "modules/utils/DecodeHTMLEntities";

const OfflineConversionCrm = () => {
  const dispatch = useDispatch();
  const [currentPipeline, setCurrentPipeline] = useState("");
  const [defaultPipeline, setDefaultPipeline] = useState(0);
  const [currentConversionStatus, setCurrentConversionStatus] = useState("");
  const [conversionStatusLoading, setConversionStatusLoading] = useState(false);
  const [showSuccessToast, setShowSuccessToast] = useState(false);
  const [showFailedToast, setShowFailedToast] = useState(false);
  const [showFailedToastNum, setShowFailedToastNum] = useState(false);
  const [showFailedToastChar, setShowFailedToastChar] = useState(false);
  const [showFailedToastDuplicate, setShowFailedToastDuplicate] = useState(false);
  const [loading, setLoading] = useState(true);
  const [lastSendDatetimes, setLastSendDatetimes] = useState({});
  const [inputFields, setInputFields] = useState();
  const [inputName, setInputName] = useState();
  const [inputInbox, setInputInbox] = useState();
  const [inputLost, setInputLost] = useState();
  const [formStandard, setFormStandard] = useState();
  const [selectedRadioValue, setSelectedRadioValue] = useState("");
  const [modalConversionDisplay, setModalConversionDisplay] = useState("hide");
  const [submitFBCRMLoading, setSubmitFBCRMLoading] = useState(false);

  // Used for get pipeline and steps
  const businessPipelinesResult = useSelector((state) => googleSelectors.getBusinessPipelinesResult(state));
  const businessStepsResult = useSelector((state) => googleSelectors.getBusinessStepsResult(state));
  const businessInfoResult = useSelector((state) => googleSelectors.getBusinessInfoResult(state));

  const facebookSettingsResult = useSelector((state) => facebookSelectors.getFacebookSettingsResult(state));
  const facebookConversionLastSent = useSelector((state) =>
    facebookSelectors.getFacebookConversionLastSentResult(state),
  );

  //eslint-disable-next-line no-unused-vars
  const [t, i18n] = useTranslation();
  const rmpToken = sessionStorage.getItem("rmp_token");
  const dropdownItems = [
    {
      title: "-",
    },
  ];

  // Get Pipelines & Lead Source
  useEffect(() => {
    setLoading(true);

    async function fetchData() {
      const pipelines = await dispatch(
        googleActions.getBusinessPipelines({
          token: rmpToken,
        }),
      );

      _forEach(pipelines.data, (value, key) => {
        if (value.default_pipeline === "Y") {
          setDefaultPipeline(parseInt(key));
          setCurrentPipeline(parseInt(key));
        }
      });
    }

    fetchData();
  }, []);

  // Get Steps
  useEffect(() => {
    if (businessPipelinesResult.data.length > 0 && currentPipeline !== "") {
      dispatch(
        googleActions.getBusinessSteps({
          token: rmpToken,
          lead_pipeline_id: businessPipelinesResult.data[currentPipeline].id,
          lang: sessionStorage.getItem("lang") ? sessionStorage.getItem("lang") : "en",
        }),
      );
    }
  }, [businessPipelinesResult, currentPipeline]);

  useEffect(() => {
    getFbBusinessStepsResult();
    setLoading(false);
  }, [businessStepsResult, facebookConversionLastSent, currentPipeline]);

  const getFbBusinessStepsResult = async () => {
    let lastSend = {};
    if (businessPipelinesResult.data.length > 0 && currentPipeline !== "") {
      const fbBusinessStepsResult = await dispatch(
        facebookActions.getFacebookConversionSettingByPipeline({
          token: rmpToken,
          pipelineId: businessPipelinesResult.data[currentPipeline].id,
        }),
      );

      if (fbBusinessStepsResult.result === 0 && fbBusinessStepsResult.data.length > 0) {
        let status = fbBusinessStepsResult.data[0].web_conversion;
        setSelectedRadioValue(status);
        setCurrentConversionStatus(status);

        if (facebookConversionLastSent.data != undefined && facebookConversionLastSent.data.length > 0) {
          fbBusinessStepsResult.data.forEach((e, i) => {
            facebookConversionLastSent.data.find(function (item, index) {
              if (item.conversion_name === e.conversion_name) {
                lastSend[item.conversion_name] = dateFormatter.formatDatetimeFull(
                  item.last_sent_datetime,
                  sessionStorage.getItem("lang"),
                );
              }
            });
          });
          setLastSendDatetimes({ ...lastSend });
        }
      } else {
        let status = "inactive";
        setSelectedRadioValue(status);
        setCurrentConversionStatus(status);
      }
      return fbBusinessStepsResult;
    }
  };

  const handleLeadConversionStatusChange = (e) => {
    setSelectedRadioValue(e.target.value);
  };

  const handleLeadConversionsCloseModal = () => {
    setModalConversionDisplay("hide");
    setSelectedRadioValue(currentConversionStatus);
  };

  const handleLeadConversions = async () => {
    try {
      setSubmitFBCRMLoading(true);
      setShowFailedToast(false);
      setShowSuccessToast(false);

      let formStandardClone = [];

      if (formStandard != undefined) {
        formStandardClone = formStandard.map((std) => {
          return { ...std };
        });
        formStandardClone.forEach((e) => {
          e.conversion_value =
            e.conversion_value != undefined && e.conversion_value != "" && e.conversion_value != null
              ? formatValue.formattedValueWithoutComma(e.conversion_value)
              : "0.00";
          e.conversion_value = parseFloat(e.conversion_value).toFixed(2);
        });
      }

      const conversions = await dispatch(
        facebookActions.setFacebookConversionSettingStatus({
          token: rmpToken,
          pipelineId: businessPipelinesResult.data[currentPipeline].id,
          pipelineSteps: formStandardClone,
          conversionStatus: selectedRadioValue,
          conversionType: "web",
        }),
      );

      if (conversions.result === 0) {
        setSubmitFBCRMLoading(false);
        setShowSuccessToast(true);
      } else {
        setSubmitFBCRMLoading(false);
        setShowFailedToast(true);
      }

      setCurrentConversionStatus(selectedRadioValue);
      setModalConversionDisplay("hide");
    } catch (error) {
      console.error("Error in handleLeadConversions:", error);
    } finally {
      setConversionStatusLoading(false);
    }
  };

  const successToastCallback = (value) => {
    setShowSuccessToast(value);
  };

  const failedToastCallback = (value) => {
    setShowFailedToast(value);
  };

  const failedToastNumCallback = (value) => {
    setShowFailedToastNum(value);
  };

  const failedToastCharCallback = (value) => {
    setShowFailedToastChar(value);
  };

  const failedToastDuplicateCallback = (value) => {
    setShowFailedToastDuplicate(value);
  };

  const handleOnSelectPipeline = async (item, index) => {
    setCurrentPipeline(index);
  };

  let inputValue = [];
  let inputInboxValue = [];
  let inputLostValue = [];

  const fetchData = async () => {
    if (businessStepsResult.result == 0 && businessPipelinesResult.result == 0) {
      if (businessPipelinesResult.data.length > 0 && currentPipeline !== "") {
        const fbBusinessStepsResult = await dispatch(
          facebookActions.getFacebookConversionSettingByPipeline({
            token: rmpToken,
            pipelineId: businessPipelinesResult.data[currentPipeline].id,
          }),
        );

        if (fbBusinessStepsResult.result == 0) {
          let fbbStepsResult = fbBusinessStepsResult != undefined ? fbBusinessStepsResult.data : [];

          let standard = businessStepsResult.data;
          let newStandard = [];

          standard.map((e) => {
            const data = businessStepsResult.data;
            const resData = data.filter((eData) => eData.conversions_name == e.conversions_name);

            if (resData.length > 0) {
              e.conversion_value = "0.00";
              newStandard.push({
                ...e,
                conversion_name: e.conversions_name,
                error: false,
                name: resData[0].name,
                folder: resData[0].folder,
                following: resData[0].following,
              });
            }
          });

          if (fbbStepsResult.length > 0) {
            newStandard.forEach((e, i) => {
              const findConversion = fbbStepsResult.find((item) => item.conversion_name == e.conversion_name);
              if (findConversion) {
                let conversionValue =
                  findConversion.conversion_value != undefined && findConversion.conversion_value != null
                    ? parseFloat(findConversion.conversion_value).toFixed(2)
                    : "0.00";
                conversionValue = formatValue.formattedValueWithComma(conversionValue);
                e.error = false;
                e.conversion_value = conversionValue;
              }
            });
          }

          setFormStandard(newStandard);

          let arrName = [];
          if (newStandard.length > 0) {
            newStandard.map((item, i) => {
              let conversionValue =
                item.conversion_value != undefined && item.conversion_value != "" && item.conversion_value != null
                  ? formatValue.formattedValueWithComma(item.conversion_value)
                  : "0.00";
              item.conversion_value = conversionValue;

              inputValue.push({
                index: i,
                conversion_value: item.conversion_value,
                name: item.name,
                conversion_name: item.conversion_name,
                following: item.following,
              });
              setInputFields(inputValue);
              arrName.push({ name: item.name, folder: item.folder });
              setInputName(arrName);
              if (item.following == "Y") {
                inputInboxValue.push(item.conversion_value);
                setInputInbox(inputInboxValue);
              }
              if (item.following == "N") {
                inputLostValue.push(item.conversion_value);
                setInputLost(inputLostValue);
              }
            });
          }
        }
      }
    }
  };

  // init input fields
  useEffect(() => {
    fetchData();
  }, [businessStepsResult, currentPipeline]);

  const RenderFormContentTable = (form, index) => {
    return form.following === "Y" && index === 0 ? (
      <>
        <tr className="rcrm-parent-title">
          <td colSpan="3">{t("__ads_crm_following_lead")}</td>
        </tr>
        <tr className="rcrm-title">
          <td>{t("__ads_crm_lead_step")}</td>
          <td>{t("__ads_crm_conversion_name")}</td>
          <td style={{ width: "100px" }} className="hideOnMobile">
            {t("__ads_initial_value")}
          </td>
        </tr>
        <tr key={index}>
          <td>{decodeHTMLEntities(form.name)}</td>
          <td>
            <div>{form.conversion_name}</div>

            <div className="hideOnDesktop">
              <label className="secondary-text">{t("__ads_initial_value")}</label>
              <InputInTable
                className={form.error ? "boxError" : ""}
                type="text"
                full
                placeHolder="0.00"
                value={form.conversion_value}
                onChange={(e) => handleFormChangeStandard(e, index)}
                onBlur={(e) => formatValueStandard(e, index)}
                margin="10px 0px !important"
              />
            </div>

            <div className="secondary-text">
              {t("__ads_crm_conversion_last_update")}:{" "}
              {lastSendDatetimes[form.conversion_name]
                ? lastSendDatetimes[form.conversion_name]
                : t("__fbads_conversion_no_data")}
            </div>
          </td>
          <td className="hideOnMobile">
            <InputInTable
              className={form.error ? "boxError" : ""}
              type="text"
              full
              placeHolder="0.00"
              value={form.conversion_value}
              onChange={(e) => handleFormChangeStandard(e, index)}
              onBlur={(e) => formatValueStandard(e, index)}
              margin="10px 0px !important"
            />
          </td>
        </tr>
      </>
    ) : form.following === "Y" && form.folder === "close_win" ? (
      <>
        <tr key={index}>
          <td>{decodeHTMLEntities(form.name)}</td>
          <td>
            <div>{form.conversion_name}</div>

            <div className="hideOnDesktop">
              <label className="secondary-text">{t("__ads_initial_value")}</label>
              <InputInTable
                className={form.error ? "boxError" : ""}
                type="text"
                full
                placeHolder="0.00"
                value={form.conversion_value}
                onChange={(e) => handleFormChangeStandard(e, index)}
                onBlur={(e) => formatValueStandard(e, index)}
                margin="10px 0px !important"
              />
            </div>

            <div className="secondary-text">
              {t("__ads_crm_conversion_last_update")}:{" "}
              {lastSendDatetimes[form.conversion_name]
                ? lastSendDatetimes[form.conversion_name]
                : t("__fbads_conversion_no_data")}
            </div>
          </td>
          <td className="hideOnMobile">
            <InputInTable
              className={form.error ? "boxError" : ""}
              type="text"
              full
              placeHolder="0.00"
              value={form.conversion_value}
              onChange={(e) => handleFormChangeStandard(e, index)}
              onBlur={(e) => formatValueStandard(e, index)}
              margin="10px 0px !important"
            />
          </td>
        </tr>
        <tr className="rcrm-parent-title">
          <td colSpan="3">{t("__ads_crm_unfollowed_lead")}</td>
        </tr>
        <tr className="rcrm-title">
          <td>{t("__ads_crm_lead_step")}</td>
          <td>{t("__ads_crm_conversion_name")}</td>
          <td style={{ width: "100px" }} className="hideOnMobile">
            {t("__ads_initial_value")}
          </td>
        </tr>
      </>
    ) : (
      <tr key={index}>
        <td>{decodeHTMLEntities(form.name)}</td>
        <td>
          <div>{form.conversion_name}</div>

          <div className="hideOnDesktop">
            <label className="secondary-text">{t("__ads_initial_value")}</label>
            <InputInTable
              className={form.error ? "boxError" : ""}
              type="text"
              full
              placeHolder="0.00"
              value={form.conversion_value}
              onChange={(e) => handleFormChangeStandard(e, index)}
              onBlur={(e) => formatValueStandard(e, index)}
              margin="10px 0px !important"
            />
          </div>

          <div className="secondary-text">
            {t("__ads_crm_conversion_last_update")}:{" "}
            {lastSendDatetimes[form.conversion_name]
              ? lastSendDatetimes[form.conversion_name]
              : t("__fbads_conversion_no_data")}
          </div>
        </td>
        <td className="hideOnMobile">
          <InputInTable
            className={form.error ? "boxError" : ""}
            type="text"
            full
            placeHolder="0.00"
            value={form.conversion_value}
            onChange={(e) => handleFormChangeStandard(e, index)}
            onBlur={(e) => formatValueStandard(e, index)}
            margin="10px 0px !important"
          />
        </td>
      </tr>
    );
  };

  const handleFormChangeStandard = (event, index) => {
    let data = [...formStandard];
    const { value } = event.target;
    const regex = /^[0-9]*(\.[0-9]*)?$/;

    if (value != "" && value != null && value != undefined) {
      let validate = regex.test(value);
      let numericValue = value.replace(/[^\d.]/g, "");
      if (validate) {
        data[index]["conversion_value"] = numericValue;
        data[index]["error"] = false;
      } else {
        data[index]["conversion_value"] = numericValue;
        data[index]["error"] = true;
      }
    } else {
      data[index]["conversion_value"] = "";
      data[index]["error"] = true;
    }
    setFormStandard(data);
  };

  const formatValueStandard = (event, index) => {
    let data = [...formStandard];
    const { value } = event.target;
    const regex = /^[0-9]*(\.[0-9]*)?$/;

    if (value != "" && value != null && value != undefined) {
      let validate = regex.test(value);
      if (validate) {
        let conversionValue = parseFloat(value).toFixed(2);
        conversionValue = formatValue.formattedValueWithComma(conversionValue);
        data[index]["conversion_value"] = conversionValue;
        data[index]["error"] = false;
      }
    }
    setFormStandard(data);
  };

  const submitForm = (e) => {
    e.preventDefault();
    let checkError = false;

    formStandard.map((e) => {
      if (e.error == true) {
        checkError = true;
        setShowFailedToastNum(true);
      }
    });

    if (!checkError) {
      handleLeadConversions();
    }
  };

  const modalLeadConversionContent = (
    <ModalContentContainer>
      <div className="info-icon">&#9432;</div>
      <div>{t("__fbads_conversion_active_confirm")}</div>
    </ModalContentContainer>
  );

  const modalLeadConversionFooter = (
    <ModalButtonContainer>
      <Button type="secondary" onClick={handleLeadConversionsCloseModal}>
        {t("__ads_crm_conversion_cancel_button")}
      </Button>
      <Button type="loading" onClick={handleLeadConversions} loading={conversionStatusLoading}>
        {t("__ads_crm_conversion_confirm_button")}
      </Button>
    </ModalButtonContainer>
  );

  let view;

  if (loading === true) {
    view = () => {
      return (
        <>
          <Loading />
        </>
      );
    };
  } else {
    view = () => {
      return (
        <>
          <Description>{t("__fbads_crm_description")}</Description>
          <form id="settingFacebook">
            <ConversionSettingHeader>
              <div className="w-50">
                <label className="secondary-text">{t("__ads_crm_lead_pipeline")}</label>
                <Dropdown
                  items={businessPipelinesResult.data.length > 0 ? businessPipelinesResult.data : dropdownItems}
                  onSelected={handleOnSelectPipeline}
                  defaultIndex={defaultPipeline}
                  minWidth="100%"
                />
              </div>
              <div className="w-50 d-flex flex-col">
                <label className="secondary-text">{t("__fbads_rcrm_conversion_sync")}</label>
                <div className="d-flex radioContainer">
                  <RadioLabelContainer>
                    <input
                      className="cursor-pointer"
                      id="sync_facebook_ads"
                      type="radio"
                      name="sync_facebook_ads"
                      onChange={handleLeadConversionStatusChange}
                      checked={selectedRadioValue == "active"}
                      value="active"
                      form="settingFacebook"
                    />
                    <label className="cursor-pointer" htmlFor="sync_facebook_ads">
                      {t("__ads_crm_conversion_send_data")}
                    </label>
                  </RadioLabelContainer>

                  <RadioLabelContainer>
                    <input
                      className="cursor-pointer"
                      id="not_sync_facebook_ads"
                      type="radio"
                      name="sync_facebook_ads"
                      onChange={handleLeadConversionStatusChange}
                      checked={selectedRadioValue == "inactive"}
                      value="inactive"
                      form="settingFacebook"
                    />
                    <label className="cursor-pointer" htmlFor="not_sync_facebook_ads">
                      {t("__ads_crm_conversion_unsend_data")}
                    </label>
                  </RadioLabelContainer>
                </div>
              </div>
            </ConversionSettingHeader>
            <Table>
              <thead>
                <tr>
                  <th className="rwidget-title">R-CRM</th>
                  <th className="facebook-ads-title" colSpan="2">
                    Meta Ads
                  </th>
                </tr>
              </thead>
              <tbody>
                {formStandard &&
                  formStandard.map((form, index) => {
                    return <React.Fragment key={index}>{RenderFormContentTable(form, index)}</React.Fragment>;
                  })}
              </tbody>
            </Table>

            <BottomSticky>
              <RowAlignRight alignItems="stretch">
                <Button type="loading" onClick={(e) => submitForm(e)} loading={submitFBCRMLoading}>
                  {t("__ads_setup_save")}
                </Button>
              </RowAlignRight>
            </BottomSticky>
          </form>

          <Toast
            show={showSuccessToast}
            message={t("__ads_crm_conversion_save_success")}
            bgColor="#4CAF50"
            callback={successToastCallback}
          ></Toast>
          <Toast
            show={showFailedToast}
            message={t("__ads_crm_conversion_save_failed")}
            bgColor="#F44336"
            callback={failedToastCallback}
          ></Toast>
          <Toast
            show={showFailedToastNum}
            message={t("__ads_crm_conversion_conversion_value_not_valid")}
            bgColor="#F44336"
            callback={failedToastNumCallback}
          ></Toast>
          <Toast
            show={showFailedToastChar}
            message={t("__ads_crm_conversion_conversion_set_not_specified")}
            bgColor="#F44336"
            callback={failedToastCharCallback}
          ></Toast>

          <Toast
            show={showFailedToastDuplicate}
            message={t("__ads_crm_conversion_conversion_set_duplicate")}
            bgColor="#F44336"
            callback={failedToastDuplicateCallback}
          ></Toast>

          <Modal
            state={modalConversionDisplay}
            content={modalLeadConversionContent}
            footer={modalLeadConversionFooter}
          />
        </>
      );
    };
  }

  return view();
};

export default OfflineConversionCrm;

const Description = styled.div`
  padding: 10px 0px;
  font-size: 14px;
  color: #999;
`;

const Table = styled.table`
  border-collapse: collapse;
  border: 1px solid #eee;
  width: 100%;
  font-size: 14px;

  .rcrm-parent-title {
    background-color: #eeeeee;
    text-align: center;
    color: #555;
  }

  .rcrm-title {
    background-color: #f9f9f9;
    color: #555;
    text-align: center;
  }

  .rcrm-no-data {
    text-align: center;
    color: #aaa;
  }

  .text-right {
    text-align: right !important;
  }

  th,
  td {
    border: 1px solid #eee;
    padding: 10px;
    font-weight: normal !important;
  }

  .rwidget-title {
    color: #fff;
    background-color: #2196f3;
    font-weight: bold !important;
  }

  .facebook-ads-title {
    color: #fff;
    background-color: #4caf50;
    font-weight: bold !important;
  }

  .cursor-pointer {
    cursor: pointer;
  }

  .secondary-text {
    color: #aaa;
    font-size: 12px;
  }

  .text-left {
    text-align: left;
  }

  .text-center {
    text-align: center;
  }

  .none-border {
    border: 1px solid transparent !important;
  }
  .border-bottom {
    border-bottom: 1px solid #eee !important;
  }
  .head-on-table {
    color: #aaa;
    font-size: 12px;
  }
  .icon-trash {
    cursor: pointer;
  }
  .span-red {
    color: #ff6962;
  }
  .react-tags {
    width: 100%;
    display: block;
    font-size: 14px;
    border-radius: 6px;
    font-family: "Poppins", "Kanit", "Helvetica Neue", sans-serif;
    min-width: 100px;
    color: #000000;
    padding: 10px 16px;
    margin: 0 0 16px;
    border: 1px solid #dddddd;
  }
  .react-tags > div > div > input {
    width: 100% !important;
    display: block;
    font-size: 14px;
    border-radius: 6px;
    min-width: 100px !important;
    color: #000000;
    padding: 10px 16px;
    margin: 0 0 8px;
    border: 1px solid #dddddd;
  }

  .hideOnDesktop {
    display: none;
  }

  @media screen and (min-width: 320px) and (max-width: 480px) {
    font-size: 13px;

    .hideOnMobile {
      display: none;
    }

    .hideOnDesktop {
      display: block;
    }

    .rwidget-title {
      width: 50%;
    }

    .rcrm-lead-step {
      width: 50%;
    }
  }
`;

const ModalContentContainer = styled.div`
  text-align: center;
  margin-bottom: 20px;
  color: #575757;
  font-weight: bold;

  .info-icon {
    font-size: 78px;
    color: #f8bb86;
    margin-bottom: 20px;
    font-weight: normal;
  }
`;

const ModalButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  padding-bottom: 16px;

  > Button {
    min-width: 100px;
    margin-bottom: 0px;
  }

  > Button:first-child {
    margin-right: 10px;
  }
`;

const RadioLabelContainer = styled.span`
  &:first-child {
    margin-right: 10px;
  }
`;

const InputInTable = styled(Input)`
  width: 100%;
  text-align: right;
  box-sizing: border-box;

  &:focus,
  &:active {
    outline: none;
    border: 1px solid #2196f3;
  }

  &.boxError {
    outline: none;
    border: 1px solid red;
  }

  &:focus.boxError {
    outline: none;
    border: 1px solid red;
  }

  @media screen and (min-width: 320px) and (max-width: 480px) {
    margin-top: 0px !important;
  }
`;

const RowAlignRight = styled(Row)`
  justify-content: flex-end;
`;

const BottomSticky = styled.div`
  position: sticky;
  bottom: -16px;
  padding: 10px;
  width: 100%;
  background: #fff;

  @media screen and (min-width: 320px) and (max-width: 480px) {
    overflow-y: hidden;
    left: 0;
    right: 0;
    margin: 0px -16px;
  }
`;

const ConversionSettingHeader = styled.div`
  display: flex;
  font-size: 14px;
  margin-bottom: 10px;

  .secondary-text {
    color: #aaa;
    font-size: 12px;
  }

  .w-50 {
    width: 50%;
    padding: 0px 10px;
    text-align: left;
  }

  .d-flex {
    display: flex;
  }

  .flex-row {
    flex-direction: row;
  }

  .flex-col {
    flex-direction: column;
  }

  .space-between {
    justify-content: space-between;
  }

  .radioContainer {
    margin-top: 0.5em;
  }

  @media screen and (min-width: 320px) and (max-width: 480px) {
    flex-direction: column;

    .w-50 {
      width: 100%;
      margin-bottom: 10px;
      text-align: left;
    }
  }
`;
